/**
 * The flag in `enabledFeatureFlags` with which a portal switches expertise over from learning-academy to the
 * leerplatform (ADR 0008). Both backends read the same flag: the leerplatform refuses the writes before, the academy
 * after, so the screens must follow it.
 */
export const EXPERTISE_IN_LEERPLATFORM = 'expertiseInLeerplatform';

/**
 * The base url of the expertise endpoints: the leerplatform API once the portal has switched expertise over, the
 * academy until then. The paths and bodies are the same on both.
 */
export const expertiseApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[EXPERTISE_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.portalApiUrl;
